export const dealersUserSubMenu = [{
  path: '/dealers-users/list/:dealerId(\\d+)',
  component: () => import('@/views/dealers-users/list.vue'),
  name: 'dealerManagement.user.title',
  meta: {
    title: 'dealerManagement.user.title',
    icon: 'user',
    noCache: true,
    hidden: true
  }
}, {
  path: '/dealers-users/add/:dealerId(\\d+)',
  component: () => import('@/views/dealers-users/manage.vue'),
  name: 'dealerManagement.user.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'dealerManagement.user.add',
    noCache: true,
    activeMenu: '/dealers-users/list/:dealerId(\\d+)',
    hidden: true
  }
}, {
  path: '/dealers-users/edit/:id(\\d+)',
  component: () => import('@/views/dealers-users/manage.vue'),
  name: 'dealerManagement.user.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'dealerManagement.user.edit',
    noCache: true,
    activeMenu: '/dealers-users/list/:dealerId(\\d+)',
    hidden: true
  }
}];